	export enum RepairLocationEnum {
		RepairInShop = 1,
		ReturnToManufacturer = 2
	}
